import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { BrandsSettings } from './settings-brands.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementBrands(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'brands',
        name: 'Brands',
        icon: 'tf-settings-brands',
        component: BrandsSettings,
        order: 1.1,
        translateName: 'SETTINGS_BRANDS.TITLE',
        resource_key: 'brands',
        required_action: 'read',
        planLockedBehavior: 'upsell',
        entitlementFeatureKey: 'brands',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
